import { render, staticRenderFns } from "./Desconocido.vue?vue&type=template&id=51b69ea6&"
import script from "./Desconocido.vue?vue&type=script&lang=js&"
export * from "./Desconocido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports